// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FQ-z","twoColumnImage":"GQ-z"};